import { PreviewVariant } from '../../../google-templates/preview-common/preview-variant.interface';
import { MetaCarouselVariablesTablePreviewComponent } from './variables-table/variables-table.component';

/**
 * Meta Carousel Ad preview variants. For now only the debug table showing every
 * variable and each card's media. No placement mocks yet.
 */
export const META_CAROUSEL_VARIANTS: PreviewVariant[] = [
  { id: 'variables-debug', platform: 'facebook', device: 'mobile', label: 'Variables (debug)', component: MetaCarouselVariablesTablePreviewComponent },
];
